/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectByConsultativeCommand } from '../../models/approve-project-by-consultative-command';
import { ApproveProjectByConsultativeCommandResult } from '../../models/approve-project-by-consultative-command-result';

export interface ApiProjectApproveProjectByConsultativePatch$Params {
      body?: ApproveProjectByConsultativeCommand
}

export function apiProjectApproveProjectByConsultativePatch(http: HttpClient, rootUrl: string, params?: ApiProjectApproveProjectByConsultativePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectByConsultativeCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectApproveProjectByConsultativePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectByConsultativeCommandResult>;
    })
  );
}

apiProjectApproveProjectByConsultativePatch.PATH = '/api/Project/ApproveProjectByConsultative';
